<ng-container *ngIf="activeSessions?.length">
  <ul [ngClass]="{ mobile: (isMobile$ | async) }">
    <ng-container *ngFor="let session of activeSessions.slice(0, displayedSessionsCount)">
      <div class="line"></div>
      <li [ngClass]="{ current: session.current }">
        <div class="col user-agent">
          <span class="bullet" [ngClass]="calculateLastActive(session.lastActiveDate) === 'online' ? 'online' : 'offline'"></span>
          <span>{{ session.browser }}, {{ session.os }}</span>
        </div>
        <div class="col location">
          <span>{{ session.country | countryName }}</span>
          <span [ngClass]="calculateLastActive(session.lastActiveDate) === 'online' ? 'online' : 'offline'">{{ calculateLastActive(session.lastActiveDate) }}</span>
        </div>
        <div class="col logout">
          <a class="logout-all uppercase" color="seccondary" (click)="deleteSpecificSession(session.id, session.current)">{{ 'WM_TECH_POOL.SESSIONS.LOGOUT' | translate }}</a>
        </div>
      </li>
    </ng-container>
    <div class="line"></div>
    <li class="last-line">
      <a class="spacer"></a>
      <a *ngIf="displayedSessionsCount < activeSessions.length" class="more uppercase" (click)="showMore()">{{ 'WM_TECH_POOL.ACTIVE_SESSIONS.SHOW_MORE' | translate }}</a>
      <a class="logout-all uppercase" (click)="deleteActiveSessions()">{{ 'WM_TECH_POOL.ACTIVE_SESSIONS.LOGOUT_ALL' | translate }}</a>
    </li>
  </ul>
</ng-container>
